module.exports = {"TXTCLI_Free_Spins":{"id":"TXTCLI_Free_Spins","defaultMessage":"Gratis spins","track":"Free Spins"}}